export default {
      id: "geo-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "sprite.svg#geo-usage",
      toString: function () {
        return this.url;
      }
    }